import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DD, DL, DT } from '../../_lib/components/DefinitionList';
import { useSonTranslation } from '../../translation/useSonTranslation';

type AttributeGroupActivityProps = {
  personCount: number;
  activity?: {
    activeLastTwelveMonths: number;
    activeLastSixMonths: number;
    activeLastMonth: number;
    activeThisMonth: number;
    neverBeenActive: number;
  };
};

/**
 * Block that shows user activity of a Attribute Group.
 */
function AttributeGroupActivity({ personCount, activity }: AttributeGroupActivityProps) {
  const { t } = useSonTranslation('AttributeGroups');

  return (
    <div className="attribute-group-activity">
      <DL modifier="inline-no-bold">
        <DT>{t('activity.personCount')}:</DT>
        <DD>{personCount}</DD>
        {activity && (
          <>
            <DT>{t('activity.activeLastTwelveMonths')}:</DT>
            <DD>{activity.activeLastTwelveMonths}</DD>
            <DT>{t('activity.activeLastSixMonths')}:</DT>
            <DD>{activity.activeLastSixMonths}</DD>
            <DT>{t('activity.activeLastMonth')}:</DT>
            <DD>{activity.activeLastMonth}</DD>
            <DT>{t('activity.activeThisMonth')}:</DT>
            <DD>{activity.activeThisMonth}</DD>
            <DT>{t('activity.neverBeenActive')}:</DT>
            <DD>{activity.neverBeenActive}</DD>
          </>
        )}
      </DL>
    </div>
  );
}

export const AttributeGroupActivityBlock = asBlock(AttributeGroupActivity, BlockType.attributegroupactivity);
export type AttributeGroupActivityBlock = ComponentProps<typeof AttributeGroupActivityBlock>;
